import { useQuery } from "react-query";
import { getFAQ } from "./api";

export const useGetFAQ = (params) => {
  return useQuery(["GET_FAQ", params], () => getFAQ(params));
};
